import { flexRender, getCoreRowModel, useReactTable } from "@tanstack/react-table"
import { useEffect, useState } from "react"

type TData = {
  id: number,
  [key: string]: any
}
interface ITableBasicParams {
  id: string
  columns: any
  fetchData: TData[]
}

export default function TableBasic(params: ITableBasicParams) {
  const columns = params.columns

  const [data, setData] = useState(() => [...params.fetchData])
  useEffect(() => {
    setData(params.fetchData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.fetchData]);
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  })

  // template 
  // header
  const theadTmp = table.getHeaderGroups().map((headerGroup) => (
    <tr key={headerGroup.id}>
      {headerGroup.headers.map((header) => (
        <th key={header.id}>
          {header.isPlaceholder
            ? null
            : flexRender(
              header.column.columnDef.header,
              header.getContext()
            )}
        </th>
      ))}
    </tr>
  ))

  const tbodyTmp = table.getRowModel().rows.map((row) => (
    <tr key={row.id}>
      {row.getVisibleCells().map((cell) => (
        <td key={cell.id}>
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </td>
      ))}
    </tr>
  ))


  return (
    <table className='table table-sm table-responsive-sm table-bordered'>
      <caption className='caption-top'>List of users</caption>
      <thead>
        {theadTmp}
      </thead>
      <tbody>
        {tbodyTmp}
      </tbody>
    </table>
  )
}